/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2CheckCircle from 'DesignSystem/Svgs/Tysiav2CheckCircle/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/ConfirmedIcon/Content"
  
}) {
let dtColorsGreen500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.500'
        })
  return (<React.Fragment
>
<Tysiav2CheckCircle
  viewPath={`${viewPath}/Tysiav2CheckCircle`}
 width={14}
 height={14}
 fill2={dtColorsGreen500}
/>
{children}
</React.Fragment>)
}